const NOTE =
  "Resultado informado pelo proprietário da EXEKUTA: projeto presente na primeira página do Google com técnicas de SEO de Alessandro Pimentel. Termos, período e métricas detalhadas não foram fornecidos nesta etapa.";

const DISCLAIMER =
  "Esta página documenta somente informações sustentadas pelo material enviado e pela confirmação do proprietário da EXEKUTA. Não são publicados percentuais, volumes de tráfego ou prazos que não tenham sido fornecidos.";

export const CASES = [
  {
    slug: "wishclean",
    name: "Wishclean",
    domain: "wishclean.com.br",
    visitUrl: "https://wishclean.com.br",
    segment: "Limpeza e higienização profissional",
    cardTitle: "Limpeza e higienização",
    screenshot: "/cases/wishclean-com-br.png",
    h1: "Wishclean: SEO para serviços de limpeza e higienização.",
    lead: "Projeto autorizado de uma empresa de limpeza e higienização, estruturado para comunicar serviços, atendimento regional e caminhos de conversão com clareza.",
    frentesLabel: "SEO local, conteúdo e conversão",
    contexto:
      "O material fornecido mostra uma operação com diferentes serviços de limpeza e higienização, páginas comerciais, áreas atendidas, perguntas frequentes e chamadas para orçamento. A estrutura combina descoberta orgânica com orientação para contato.",
    frentes: [
      { title: "Cobertura de serviços", desc: "Organização das principais soluções em páginas e blocos que ajudam o usuário a identificar rapidamente o serviço procurado." },
      { title: "Presença regional", desc: "Uso de áreas de atendimento e contexto local para aproximar a oferta das buscas geograficamente relevantes." },
      { title: "Conversão", desc: "Chamadas de orçamento e contato distribuídas ao longo da jornada para transformar descoberta em solicitação." },
    ],
  },
  {
    slug: "rio-quadras",
    name: "Rio Quadras",
    domain: "rioquadras.com.br",
    visitUrl: "https://rioquadras.com.br",
    segment: "Engenharia esportiva e construção de quadras",
    cardTitle: "Engenharia esportiva e quadras",
    screenshot: "/cases/rioquadras-wide.png",
    h1: "Rio Quadras: SEO para engenharia e espaços esportivos.",
    lead: "Projeto autorizado voltado a engenharia esportiva, construção, reforma e manutenção de quadras, com organização de soluções para diferentes demandas do mercado.",
    frentesLabel: "Estratégia SEO, arquitetura e conteúdo",
    contexto:
      "O material enviado apresenta uma empresa especializada em quadras e espaços esportivos, com navegação para soluções, projetos, conteúdo e contato. A proposta comercial cobre construção, reforma, pisos e manutenção.",
    frentes: [
      { title: "Arquitetura de soluções", desc: "Separação de serviços e aplicações para atender diferentes intenções de busca dentro do universo de quadras esportivas." },
      { title: "Conteúdo setorial", desc: "Estrutura preparada para páginas informativas e comerciais que ampliam a cobertura temática do domínio." },
      { title: "Autoridade visual", desc: "Uso de projetos e imagens de execução para reforçar especialização técnica e reduzir incerteza do potencial cliente." },
    ],
  },
  {
    slug: "terraplanagem-rio",
    name: "Terraplanagem Rio",
    domain: "terraplanagem.rio.br",
    visitUrl: "https://terraplanagem.rio.br",
    segment: "Terraplanagem e locação de equipamentos",
    cardTitle: "Terraplanagem e locação",
    screenshot: "/cases/terraplanagem-rio-br.png",
    h1: "Terraplanagem.rio.br: SEO para demanda regional e locação.",
    lead: "Projeto autorizado para captação de demanda regional ligada a terraplanagem e locação de equipamentos, com comunicação direta de máquinas, serviços e orçamento.",
    frentesLabel: "SEO local e páginas comerciais",
    contexto:
      "O material enviado mostra uma operação centrada em máquinas de terraplanagem e escavação, com destaque para locação, tipos de equipamento, clientes e formulário de cotação.",
    frentes: [
      { title: "Demanda regional", desc: "Estrutura voltada a buscas associadas ao Rio de Janeiro e à contratação de serviços de terraplanagem." },
      { title: "Páginas de equipamento", desc: "Separação das principais máquinas e modalidades de locação para responder a necessidades comerciais específicas." },
      { title: "Cotação", desc: "Formulários e CTAs próximos aos blocos de serviço para encurtar o caminho entre busca e solicitação comercial." },
    ],
  },
  {
    slug: "sinteko",
    name: "Sinteko",
    domain: "sinteko.com.br",
    visitUrl: "https://sinteko.com.br",
    segment: "Pisos, sinteco e acabamentos",
    cardTitle: "Pisos e acabamentos",
    screenshot: "/cases/sinteko-com-br.png",
    h1: "Sinteko: SEO para serviços de pisos e acabamentos.",
    lead: "Projeto autorizado focado em serviços de sinteco e conservação de pisos, com páginas de serviço, portfólio, conteúdo educativo e solicitação de orçamento.",
    frentesLabel: "Conteúdo, SEO local e páginas de serviço",
    contexto:
      "O material enviado mostra uma apresentação especializada em sinteco no Rio de Janeiro, com explicação do serviço, variações de aplicação, projetos, depoimento, blog e formulário.",
    frentes: [
      { title: "Páginas especializadas", desc: "Conteúdo organizado por serviço e aplicação para responder a buscas mais específicas do que um termo institucional amplo." },
      { title: "Portfólio", desc: "Demonstrações de projetos ajudam a contextualizar o serviço e reforçar confiança antes do contato." },
      { title: "Conteúdo de apoio", desc: "Artigos e explicações ampliam a cobertura de dúvidas relacionadas a conservação e recuperação de pisos." },
    ],
  },
  {
    slug: "loca-rental",
    name: "Loca Rental",
    domain: "locarental.com.br",
    visitUrl: "https://locarental.com.br",
    segment: "Locação de máquinas pesadas",
    cardTitle: "Locação de máquinas",
    screenshot: "/cases/locarental-com-br.png",
    h1: "Loca Rental: SEO para locação de máquinas pesadas.",
    lead: "Projeto autorizado para locação de máquinas pesadas, estruturado para apresentar frota, serviços de terraplanagem e caminhos de cotação em uma jornada comercial direta.",
    frentesLabel: "Estratégia SEO e geração de leads",
    contexto:
      "O material fornecido destaca locação de retroescavadeira e outras máquinas, soluções de terraplanagem, razões para contratar, depoimentos, artigos e contato.",
    frentes: [
      { title: "Intenção de locação", desc: "Páginas e CTAs orientados a usuários que já pesquisam máquinas ou serviços específicos para uma obra." },
      { title: "Prova de capacidade", desc: "Apresentação visual da frota e da operação para reduzir dúvidas sobre estrutura e disponibilidade." },
      { title: "Geração de leads", desc: "Fluxos de orçamento posicionados em pontos estratégicos do site para facilitar a solicitação comercial." },
    ],
  },
  {
    slug: "rio-pintura",
    name: "Rio Pintura",
    domain: "riopintura.com.br",
    visitUrl: "https://riopintura.com.br",
    segment: "Pintura residencial, comercial e predial",
    cardTitle: "Pintura residencial",
    screenshot: "/cases/riopintura-com-br.png",
    h1: "Rio Pintura: SEO para serviços de pintura no Rio de Janeiro.",
    lead: "Projeto autorizado para serviços de pintura no Rio de Janeiro, com organização por tipo de serviço, portfólio visual, prova social e contato comercial.",
    frentesLabel: "SEO local, serviços e conversão",
    contexto:
      "O material enviado apresenta serviços de pintura residencial, comercial e predial, além de diferenciais, galeria de trabalhos, depoimentos e conteúdo de blog.",
    frentes: [
      { title: "Serviços segmentados", desc: "Separação das modalidades de pintura para atender buscas com necessidades e contextos distintos." },
      { title: "Relevância local", desc: "Comunicação orientada ao Rio de Janeiro para aproximar a oferta das pesquisas regionais." },
      { title: "Prova visual", desc: "Galeria de ambientes e trabalhos ajuda a demonstrar o resultado esperado antes do pedido de orçamento." },
    ],
  },
  {
    slug: "rio-eletrica",
    name: "Rio Elétrica",
    domain: "rioeletrica.com.br",
    visitUrl: "https://rioeletrica.com.br",
    segment: "Engenharia e serviços elétricos",
    cardTitle: "Engenharia elétrica",
    screenshot: "/cases/rioeletrica-com-br.png",
    h1: "Rio Elétrica: SEO para engenharia e serviços elétricos.",
    lead: "Projeto autorizado para uma operação de engenharia elétrica, com organização técnica de serviços e comunicação voltada a empresas, indústrias e projetos especializados.",
    frentesLabel: "SEO técnico, arquitetura e páginas comerciais",
    contexto:
      "O material fornecido apresenta projetos elétricos, infraestrutura, manutenção, subestações, média tensão, redes subterrâneas e outras soluções técnicas.",
    frentes: [
      { title: "Arquitetura técnica", desc: "Divisão de soluções elétricas em frentes específicas para reduzir ambiguidade e melhorar a relação entre busca e serviço." },
      { title: "Profundidade comercial", desc: "Cards e páginas de serviço ajudam o visitante a compreender escopo, aplicação e próximo passo." },
      { title: "Confiança B2B", desc: "A apresentação de processos, responsabilidade e engenharia reforça o posicionamento para demandas empresariais." },
    ],
  },
  {
    slug: "synteco",
    name: "Synteco",
    domain: "synteco.com.br",
    visitUrl: "https://synteco.com.br",
    segment: "Serviços especializados",
    cardTitle: "Serviços especializados",
    screenshot: "/cases/synteco-com-br.svg",
    h1: "Synteco: case de SEO para serviços especializados.",
    lead: "Projeto autorizado incluído no portfólio da EXEKUTA como um case independente de Sinteko.com.br, com resultado de primeira página informado pelo proprietário da marca.",
    frentesLabel: "Páginas comerciais, conteúdo e presença orgânica",
    contexto:
      "Nesta etapa não foi fornecida uma captura oficial específica nem um conjunto detalhado de métricas, período ou palavras-chave do projeto Synteco. Por isso, a página preserva apenas os fatos confirmados e mantém a estrutura pronta para aprofundamento.",
    frentes: [
      { title: "Presença orgânica", desc: "O projeto foi informado como posicionado na primeira página do Google com técnicas de SEO de Alessandro Pimentel." },
      { title: "Estrutura comercial", desc: "A página de case está preparada para documentar serviços, páginas estratégicas e intenções de busca quando o material for disponibilizado." },
      { title: "Validação futura", desc: "Termos posicionados, período, métricas e fontes podem ser incorporados sem alterar a arquitetura do case." },
    ],
  },
];

export const CASE_NOTE = NOTE;
export const CASE_DISCLAIMER = DISCLAIMER;
export const CASE_RESULT = "1ª página do Google";
